import './subscriptionBlock.scss';

import { addGtmTrackingToEpiserverForms } from '@/components/EpiserverForms';

const subscriptionBlockDivs = document.getElementsByClassName(
  'container--subscriptionBlock',
);

if (subscriptionBlockDivs) {
  Array.from(subscriptionBlockDivs).forEach((element) => {
    addGtmTrackingToEpiserverForms(element, 'SubscriptionBlock');
  });
}
